/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Chat_Citations_Searched_ForInputs */



/**
* | output |
* | --- |
* | "Websearch \"{query}\"" |
*
* @param {Chat_Citations_Searched_ForInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_citations_searched_for = /** @type {((inputs: Chat_Citations_Searched_ForInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Citations_Searched_ForInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Internetsuche „${i?.query}“`)
	return /** @type {LocalizedString} */ (`Websearch "${i?.query}"`)
});